module.exports = __webpack_public_path__ + "static/media/8.0739a8e3.jpg";